import { useForm } from 'react-hook-form'
import { IDealer } from 'safe'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import FieldArrayPhone from '../../components/Inputs/FieldArrayPhone'
import Select from '../../components/Inputs/Select'
import { emailRegex } from '../../utils/validations'
import { useLocalStorageState } from '../../hooks/useLocalStorageState'
import { TextArea } from '../../components/Inputs/TextArea'
import InputCheck from '../../components/Inputs/InputCheck'
import { useEffect, useRef, useState } from 'react'
import InputNumber from '../../components/Inputs/InputNumber'
import { onCheckCb } from '../../utils/onCheckIfExistCb'
import { BsDownload } from 'react-icons/bs'

const DealersForm: React.FC<DealersFormProps> = ({
  id,
  onSubmit,
  onDelete,
  onCancel,
  useType = 'create',
  defaultValues,
  submitting,
}) => {
  const [typeDocumentSelected, setTypeDocumentSelected] = useState<{
    value: number | string
    text: string
  }>({
    value: 'V',
    text: 'V',
  })
  const [specialContributor, setSpecialContributor] = useState<boolean>(false)

  const [userConfig] = useLocalStorageState('user-config')

  let inputSubmitFileRef = useRef<HTMLInputElement | null>(null)

  const [dealerFile, setDealerFile] = useState<File | null>(null)

  const [alreadySubmitted, setAlreadySubmitted] = useState<boolean>(false)

  const getDoc = () => {
    let doc = docs.find((d) => d.value === defaultValues.document.documentType)
    return doc
  }

  const getPhones = () => {
    // if (defaultValues?.phone1 && defaultValues?.phone2) {
    //   return [{number: defaultValues?.phone1}, {number: defaultValues?.phone2}]
    // }
    // if (defaultValues?.phone1) {
    //   return [{number: defaultValues?.phone1}]
    // }
    // return []
    let transform = {
      '58': 1,
      '1': 2,
      '57': 3
    }
    if (defaultValues?.phone1 && defaultValues?.phone2) {
      const [country, number] = defaultValues?.phone1?.split(" ") 
      const [country2, number2] = defaultValues?.phone2?.split(" ") 
      return [{number, country: {id: transform[country] || 2 }}, {number: number2, country: {id: transform[country2] || 2 }}]
    }
    if (defaultValues?.phone1) {
      const [country, number] = defaultValues?.phone1?.split(" ") 
      return [{number, country: {id: transform[country] || 2 }}]
    }
    return []
  }

  useEffect(() => {
    setSpecialContributor(defaultValues?.contributing_special)
    // Actualizar el tipo de documento seleccionado cuando se edita
    if (defaultValues?.document?.documentType) {
      const docType = defaultValues.document.documentType
      setTypeDocumentSelected({ value: docType, text: docType })
    }
    console.log('defaultValues: ', defaultValues)
    console.log('specialContributor: ', specialContributor)
  }, [defaultValues])

  const docs = [
    {
      value: 'J',
      text: 'J',
    },
    {
      value: 'V',
      text: 'V',
    },
    {
      value: 'E',
      text: 'E',
    },
    {
      value: 'P',
      text: 'P',
    },
    {
      value: 'G',
      text: 'G',
    },
    {
      value: 'C',
      text: 'C',
    },
  ]

  const countries = [
    {
      value: 1,
      text: '+58',
    },
    {
      value: 2,
      text: '+1',
    },
    {
      value: 3,
      text: '+57',
    },
  ]

  const form = useForm<IDealer>({
    defaultValues: {
      ...defaultValues,
      phones: getPhones(),
      document: {
        ...defaultValues?.document,
        documentType: useType === 'create' ? docs[0].value : getDoc()?.value,
      },
    },
  })

  const onSubmitImage = (e) => {
    e.preventDefault()
    if (inputSubmitFileRef.current && inputSubmitFileRef.current.files) {
      console.log('in...')
      // console.log("VER", inputSubmitFileRef.current.files.item(0))
      setDealerFile(inputSubmitFileRef?.current?.files[0])
    }
  }

  return (
    <div className="m-auto">
      <h2 className="text-primary-900 font-bold dark:text-white mb-5">
        Empresa
      </h2>
      <Form
        form={form}
        classes={`gap-x-6 gap-y-2`}
        id={id}
        onSubmit={(values) => {
          console.log('Dealer file', dealerFile)
          let transform = {
            1: '58',
            2: '1',
            3: '57'
          }
          // Para V, E, P, C y G, copiar name a businessName
          const docType = values?.document?.documentType
          const shouldCopyNameToBusinessName = ['V', 'E', 'P', 'C', 'G'].includes(docType)
          const businessName = shouldCopyNameToBusinessName ? values?.name : values?.businessName

          onSubmit({
            ...values,
            id: defaultValues?.id,
            dealerFile,
            businessName,
            phones: values?.phones?.map(v => ({...v, country: {id: transform[v?.country?.id]}}))
          })
        }}
        style={{ width: '100%' }}
      >
        <FormItem
          name="document.documentType"
          defaultValue={useType === 'create' ? docs[0] : getDoc()}
          rules={{ required: 'Es necesario el campo' }}
          classes="xl:col-start-3 col-start-1 xl:col-span-2 col-span-3"
        >
          <Select
            options={docs}
            label="Tipo"
            setSelectedHelper={async (v) => {
              setTypeDocumentSelected(v)
              let value = await onCheckCb(
                useType,
                form.getValues().document.document,
                v.value,
                userConfig.rowsPerPage,
                '/thirdparty/provider?',
                'providers'
              )
              if (value) {
                form?.setError('document.document', {
                  type: 'manual',
                  message: 'Proveedor ya existe',
                })
              } else {
                form?.clearErrors('document.document')
              }
            }}
          />
        </FormItem>
        <FormItem
          name="document.document"
          rules={{
            required: 'Es necesario el documento',
            pattern: { value: /^\d+$/, message: 'Documento inválido' },
            minLength: {
              value: 6,
              message: 'El documento debe de poseer al menos 6 caracteres.',
            },
          }}
          classes="xl:col-span-8 col-span-9"
        >
          <InputText
            label="Documento"
            onCheckIfExist={async () => {
              let value = await onCheckCb(
                useType,
                form.getValues().document.document,
                form.getValues().document.documentType,
                userConfig.rowsPerPage,
                '/thirdparty/provider?',
                'providers'
              )
              if (value) {
                form?.setError('document.document', {
                  type: 'manual',
                  message: 'Proveedor ya existe',
                })
              } else {
                form?.clearErrors('document.document')
              }
            }}
          />
        </FormItem>

        {typeDocumentSelected.value === 'J' ? (
          <>
            <FormItem
              name="businessName"
              classes="xl:col-start-3 xl:col-span-10 col-span-12"
              rules={{ required: 'El campo nombre es requerido' }}
            >
              <InputText small label="Razón Social" maxLength={100} />
            </FormItem>

            <FormItem
              name="commercialName"
              classes="xl:col-start-3 xl:col-span-10 col-span-12"
              // rules={{ required: 'El campo nombre comercial es requerido' }}
            >
              <InputText small label="Nombre Comercial" maxLength={100} />
            </FormItem>
          </>
        ) : typeDocumentSelected.value === 'G' ? (
          <>
            <FormItem
              name="name"
              classes="xl:col-start-3 xl:col-span-10 col-span-12"
              rules={{ required: 'El campo razón social es requerido' }}
            >
              <InputText small label="Razón Social" maxLength={100} />
            </FormItem>
          </>
        ) : (
          <>
            <FormItem
              name="name"
              classes="xl:col-start-3 xl:col-span-10 col-span-6"
              rules={{ required: 'El campo nombre es requerido' }}
            >
              <InputText small label="Nombre y apellido" maxLength={100} />
            </FormItem>

            {/* <FormItem
              name="surname"
              classes="xl:col-span-5 col-span-6"
              rules={{ required: 'El campo apellido es requerido' }}
            >
              <InputText small label="Apellidos" maxLength={100} />
            </FormItem> */}
          </>
        )}

        <FormItem
          name="email"
          classes="xl:col-start-3 xl:col-span-10 col-span-12"
          rules={{
            pattern: {
              value: emailRegex,
              message: 'El email ingresado debe ser válido',
            },
          }}
        >
          <InputText
            small
            label="Correo"
            maxLength={255}
            isUpperValue={false}
          />
        </FormItem>

        <div className="xl:col-start-3 xl:col-span-5 col-span-5 flex flex-row ">
          <FormItem name="contributingSpecial" classes="w-2/5 mt-7">
            <InputCheck
              value={specialContributor}
              label="Contribuyente Especial"
              helperFunction={(v) => setSpecialContributor(v)}
            />
          </FormItem>

          {specialContributor && (
            <FormItem
              name="withholdingTax"
              classes="w-2/6"
              rules={{
                required: 'Es necesario ingresar el valor del impuesto',
                min: { value: 1, message: 'Campo debe ser mayor a 1%' },
                max: { value: 100, message: 'Campo debe ser no mayor al 100%' },
                valueAsNumber: true,
              }}
            >
              <InputNumber min={0} max={100} label="Retención (0-100%)" />
            </FormItem>
          )}
        </div>

        <div className="xl:col-span-4 col-span-4 mt-7">
          <div className="flex justify-between items-center">
            {/* <BsDownload onClick={() => window.open('https://nevula-test.s3.amazonaws.com/1/provider/pdf/zTVKKFB3Epvs.xlsx')} /> */}
            {/* <u
              // loading={submitting}
              className='text-xs'
              onClick={() =>
                inputSubmitFileRef.current && inputSubmitFileRef.current.click()
              }
              style={{color: "#006AEA", cursor: 'pointer'}}
            >
              Subir documento
            </u> */}

            <input
              type="file"
              ref={inputSubmitFileRef}
              onChange={onSubmitImage}
            />
          </div>
        </div>

        <h2 className="col-span-12 mt-1 text-primary-900 font-bold dark:text-white mt-4">
          Dirección
        </h2>

        {/* <FormItem
          name="address.street"
          classes="xl:col-start-3 xl:col-span-5 col-span-6"
          // rules={{ required: 'Es necesaria ingrsar la calle' }}
        >
          <InputText small label="Calle" maxLength={50} />
        </FormItem>

        <FormItem
          name="address.neighborhood"
          classes="xl:col-span-5 col-span-6"
          // rules={{ required: 'Es necesaria ingresar el sector' }}
        >
          <InputText small label="Sector" maxLength={50} />
        </FormItem>

        <FormItem
          name="address.avenue"
          classes="xl:col-start-3 xl:col-span-5 col-span-6"
          // rules={{ required: 'Es necesaria ingresar la avenida' }}
        >
          <InputText small label="Avenida" maxLength={50} />
        </FormItem>

        <FormItem
          name="address.building"
          classes="xl:col-span-5 col-span-6"
          // rules={{ required: 'Es necesaria ingresar una dirección de casa o edificio' }}
        >
          <InputText small label="Casa / Edificio" maxLength={50} />
        </FormItem> */}

        <FormItem
          name="address.fiscalAddress"
          classes="xl:col-start-3 xl:col-span-10 col-span-12 lg:col-span-12"
          rules={{ required: 'Es necesario ingresar la dirección fiscal' }}
        >
          <TextArea
            label="Dirección RIF"
            placeholder="Ingresar dirección exacta del RIF"
            maxLength={255}
          />
        </FormItem>

        <FormItem
          name="address.country"
          classes="xl:col-start-3 xl:col-span-5 col-span-6"
          defaultValue={userConfig?.default?.country}
          rules={{ required: 'Es necesario ingresar el país' }}
        >
          <InputText small label="País" maxLength={50} />
        </FormItem>

        <FormItem
          name="address.city"
          classes="xl:col-span-5 col-span-6"
          rules={{ required: 'Es necesario la ciudad' }}
          defaultValue={userConfig?.default?.city}
        >
          <InputText small label="Ciudad" maxLength={50} />
        </FormItem>

        <FormItem
          name="address.state"
          classes="xl:col-start-3 xl:col-span-5 col-span-6"
          rules={{ required: 'Es necesario el estado' }}
          defaultValue={userConfig?.default?.province}
        >
          <InputText small label="Estado" maxLength={50} />
        </FormItem>

        <FormItem
          name="address.postalCode"
          classes="xl:col-span-5 col-span-6"
          rules={{ required: 'Es necesario ingresar un codigo postal' }}
          defaultValue={userConfig?.default?.PC}
        >
          <InputText small label="Código Postal" maxLength={10} />
        </FormItem>

        <h2 className="col-span-12 col-start-1 mt-1 text-primary-900 font-bold dark:text-white mt-4">
          Teléfonos
        </h2>

        <FieldArrayPhone name="phones" fieldLength={2}>
          <FormItem
            name="country.id"
            rules={{
              required: 'Es necesario el campo',
            }}
            classes="xl:col-start-3 xl:col-span-2 col-start-1 col-span-4"
          >
            <Select
              options={countries}
              label="Código"
              defaultValue={countries[0]}
            />
          </FormItem>

          <FormItem
            name="number"
            classes="xl:col-span-7 col-span-7"
            rules={{
              pattern: { value: /^\d+$/, message: 'Campo de tipo númerico' },
            }}
            alreadySubmitted={alreadySubmitted}
          >
            <InputText small phone={true} label="Teléfono" maxLength={15} />
          </FormItem>
        </FieldArrayPhone>

        {/* <FormItem name="address.id" classes="lg:col-span-4 col-span-12">
          <InputText small label="address.id" hidden />
        </FormItem>

        <FormItem name="address.type">
          <InputText label="type" value="common" hidden />
        </FormItem>

        <FormItem name="address.headquarters">
          <InputText label="headquarters" value="headquarters" hidden />
        </FormItem> */}

        <div className="col-span-12 h-full flex flex-row">
          <div className="w-1/2 mr-5 pl-1">
            <Button
              onClick={() => {
                if (onCancel) onCancel()
              }}
              type="outline"
              loading={submitting}
              classes="w-full"
            >
              Cancelar
            </Button>
          </div>
          <div className="w-1/2 pr-2">
            <Button
              type="primary"
              loading={submitting}
              classes="w-full"
              htmlType="submit"
              onClick={() => setAlreadySubmitted(true)}
            >
              {useType === 'create' ? 'Añadir' : 'Guardar cambios'}
            </Button>
          </div>
        </div>
      </Form>
    </div>
  )
}

export default DealersForm

interface DealersFormProps {
  onSubmit: Function
  onDelete?: Function
  onCancel?: Function
  useType?: 'create' | 'edit'
  defaultValues?: object | any
  submitting?: boolean
  id?: string
  preloadedData?: object | any
}
